import { Box } from "@chakra-ui/react";
import Modal from "src/components/Modal";

export default function PopoverView({
  children,
  fluid = false,
  width = "632px",
  height = fluid ? "90vh" : "424px",
  maxHeight = "824px",
  isOpen = true,
  onClose,
  ...rest
}) {
  return (
    <Modal isOpen={isOpen} onClose={onClose} {...rest}>
      <Box
        width={width}
        height={height}
        maxHeight={maxHeight}
        position="relative"
        overflow="hidden"
      >
        {children}
      </Box>
    </Modal>
  );
}
